import { siteLogo } from "./api";

export const DEFAULT_DOCUMENT_BUSINESS_NAME = "NAWADAH by NDH Official";
export const DEFAULT_DOCUMENT_WHATSAPP = "0857-1750-0023";

const value = (candidate) => String(candidate || "").trim();

export function resolveDocumentIdentity(document = {}, settings = {}) {
  return {
    name: value(document.business_name) || value(settings.business_name) || value(settings.company_name) || DEFAULT_DOCUMENT_BUSINESS_NAME,
    logo: value(document.business_logo) || siteLogo(settings),
    whatsapp: value(document.business_whatsapp) || value(settings.whatsapp) || DEFAULT_DOCUMENT_WHATSAPP,
  };
}

export function documentIdentityFormValues(document = {}, settings = {}) {
  const identity = resolveDocumentIdentity(document, settings);
  return {
    business_name: identity.name,
    business_logo: identity.logo,
    business_whatsapp: identity.whatsapp,
  };
}
